import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { applyBreakpoints, md } from '../../../../utils/breakpoints';
import { mapStateToProps } from '../../../../utils/mapper';
import { button, colors } from '../../../../utils/styles';
import MenuItem from './menu_item';

import { equals, reduce } from 'ramda';

import Chevron from '../../../../modules/svgs/chevron';

interface MenuSectionProps {
  url?: string;
  title?: string;
  options?: any[];
  items?: any[];
  last: boolean;
  window: { width: number, multiplier: number, landscape: boolean };
  dispatch: ({ type }: { type: string; [key: string]: any }) => void;
  index: number;
  catcherPress: () => void;
  menu: { menuItems: any };
};

const styles = {
  mainMenuSection: RX.Styles.createViewStyle({
    backgroundColor: colors.background,
    borderBottomWidth: 1,
    borderColor: colors.lightGrey,
    padding: 16,
  }),
};

const checkMenuItems = (a, b) => {
  if (a && b && a.length === b.length) {
    return reduce((acc, item) => equals(item, b[a.indexOf(item)]), false, a);
  }
  return false;
}

export class MenuSection
  extends RX.Component<MenuSectionProps, RX.CommonProps & { mouseOver: boolean}> {

  constructor(props: MenuSectionProps) {
    super(props);
    this.state = { mouseOver: false };
    this.showItems = this.showItems.bind(this);
    this.mouseOver = this.mouseOver.bind(this);
  }

  public render() {
    const { url, title, items, last, window: { width, multiplier, landscape }, catcherPress, menu: { menuItems } } = this.props; //tslint:disable-line

    return (
      <RX.View
        onMouseEnter={() => this.mouseOver(true)}
        onMouseLeave={() => this.mouseOver(false)}
        onPress={width < md ? () => {} : this.showItems} //tslint:disable-line
        style={[
          styles.mainMenuSection,
          width < md
          ? { width, paddingHorizontal: landscape ? 45 : 16 }
          : {
            alignItems: 'center',
            backgroundColor: colors.white,
            borderBottomWidth: 0,
            cursor: 'pointer',
            flexDirection: 'row',
            justifyContent: 'center',
            padding: 0,
            paddingRight: 4 * multiplier,
            width: 300 * multiplier,
          },
          last ? { borderBottomWidth: 0 } : {}
        ]}
      >
        {title && title === 'Where do I go for care?' ?
        <a
                        style={{
                            height: 40 * multiplier,
                            paddingBottom: 8 * multiplier,
                            paddingTop: 8 * multiplier,
                            textDecoration: 'none'
                        }}
                        href={url}
                    >
                            <RX.Text style={{
                                color: colors.grey,
                                fontSize: 18 * multiplier,
                                fontWeight: '700',
                            }}>{title}</RX.Text>
                        </a>
        :
          <RX.Text
            style={[
              button(multiplier),
              { marginBottom: 8 * multiplier, color: colors.primary, fontWeight: '700' },
              ...applyBreakpoints(width, {
                md: {
                  backgroundColor: colors.white,
                  color: this.state.mouseOver || checkMenuItems(items, menuItems) ? colors.hoverBlue : colors.grey,
                  marginBottom: 0,
                  padding: 8
                }})
              ]}>{title}</RX.Text>
              }
          {width >= md && title !== 'Where do I go for care?' &&
            <Chevron
              color={this.state.mouseOver || checkMenuItems(items, menuItems) ? colors.hoverBlue : colors.menuRed}
            />
          }
        {width < md
          && items
          && items.map((item) => <MenuItem key={item.title} { ...item } { ... { catcherPress }} />)}
      </RX.View>
    );
  };

  private showItems() {
    const { window: { width }, index, items, dispatch } = this.props;
    if (this.props.title === 'Where do I go for care?') {
      return;
    }
    dispatch({
      menuItems: items,
      right: (300 * index) + (width > 1200 ? (width - 1200) / 2 + 38 : 38),
      type: 'SHOW_MENU_ITEMS',
    });
  }

  private mouseOver(mouseState: boolean) {
    this.setState({ mouseOver: mouseState});
  }
}

export default connect(mapStateToProps)(MenuSection);



// WEBPACK FOOTER //
// ./src/components/menu/menu_container/menu_section/index.tsx